<template>
  <div class="row">
    <div class="col-12 g">
      <div class="card">
        <div class="card-header">
          <div>
            <h4 class="mb-25">
              <i class="fa fa-bullhorn"></i>
              رسائل التطبيقات
            </h4>
            <span class="text-muted">رسالة أو إعلان يظهر داخل التطبيقات الجديدة لكل أولياء الأمور أو المعلمين أو المدارس عند فتح التطبيق.</span>
          </div>
          <button class="btn btn-primary" @click="openNew()">
            <i class="fa fa-plus"></i> رسالة جديدة
          </button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover">
              <thead>
                <tr>
                  <th>الرسالة</th>
                  <th>تظهر في</th>
                  <th>الإغلاق</th>
                  <th>الحالة</th>
                  <th>خيارات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="m in list" :key="m._id">
                  <td class="msg">
                    <strong>{{ m.title || '(بدون عنوان)' }}</strong>
                    <small class="text-muted d-block">{{ m.message }}</small>
                    <small v-if="m.link" class="d-block" dir="ltr">{{ m.link }}</small>
                  </td>
                  <td>
                    <span v-for="a in m.apps" :key="a" class="badge badge-light-primary ml-25">{{ appName(a) }}</span>
                  </td>
                  <td>
                    <small v-if="m.allow_hide">يقدر يخفيها نهائياً</small>
                    <small v-else>ترجع مع كل فتح للتطبيق</small>
                  </td>
                  <td>
                    <button class="btn btn-sm" :class="m.active ? 'btn-success' : 'btn-outline-secondary'" @click="toggle(m)">
                      <i class="fa" :class="m.active ? 'fa-eye' : 'fa-eye-slash'"></i>
                      {{ m.active ? 'تظهر الآن' : 'موقوفة' }}
                    </button>
                  </td>
                  <td class="actions">
                    <button class="btn btn-sm btn-outline-primary" @click="openEdit(m)"><i class="fa fa-edit"></i> تعديل</button>
                    <button v-if="m.allow_hide" class="btn btn-sm btn-outline-warning" @click="reshow(m)" title="تظهر مرة أخرى لمن اختار عدم إظهارها"><i class="fa fa-undo"></i> إظهار لمن أخفاها</button>
                    <button class="btn btn-sm btn-outline-danger" @click="remove(m)"><i class="fa fa-trash"></i> حذف</button>
                  </td>
                </tr>
                <tr v-if="!list.length">
                  <td colspan="5" class="text-center text-muted">لا توجد رسائل. اضغط «رسالة جديدة» لإضافة أول رسالة.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="message" :title="form._id ? 'تعديل الرسالة' : 'رسالة جديدة'" hide-footer size="lg">
      <div class="row">
        <div class="col-12 col-lg-7">
          <div class="form-group">
            <label>تظهر في تطبيق</label>
            <div>
              <div v-for="(name, key) in appNames" :key="key" class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" :id="'app-' + key" :value="key" v-model="form.apps">
                <label class="custom-control-label" :for="'app-' + key">{{ name }}</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="m-title">العنوان</label>
            <input id="m-title" class="form-control" v-model="form.title" placeholder="مثال: إعلان مهم">
          </div>
          <div class="form-group">
            <label for="m-message">النص</label>
            <textarea id="m-message" class="form-control" rows="5" v-model="form.message"></textarea>
          </div>
          <div class="form-row">
            <div class="form-group col-7">
              <label for="m-link">رابط (اختياري)</label>
              <input id="m-link" class="form-control" dir="ltr" v-model.trim="form.link" placeholder="https://">
            </div>
            <div class="form-group col-5">
              <label for="m-link-text">نص زر الرابط</label>
              <input id="m-link-text" class="form-control" v-model="form.link_text" placeholder="فتح الرابط">
            </div>
          </div>
          <div class="custom-control custom-switch mb-1">
            <input type="checkbox" class="custom-control-input" id="m-allow-hide" v-model="form.allow_hide">
            <label class="custom-control-label" for="m-allow-hide">السماح للمستخدم بإخفائها نهائياً (زر «عدم الإظهار مرة أخرى»)</label>
          </div>
          <small class="text-muted d-block mb-1" v-if="!form.allow_hide">بدون هذا الخيار: زر «إغلاق» فقط، وترجع الرسالة كل مرة يفتح فيها التطبيق.</small>
          <div class="custom-control custom-switch mb-1">
            <input type="checkbox" class="custom-control-input" id="m-active" v-model="form.active">
            <label class="custom-control-label" for="m-active">تظهر الآن</label>
          </div>
        </div>
        <div class="col-12 col-lg-5">
          <label>معاينة</label>
          <div class="preview">
            <div class="preview-card">
              <div class="preview-icon"><i class="fa fa-bullhorn"></i></div>
              <strong v-if="form.title">{{ form.title }}</strong>
              <p v-if="form.message">{{ form.message }}</p>
              <span class="preview-btn">{{ form.link ? (form.link_text || 'فتح الرابط') : 'إغلاق' }}</span>
              <span v-if="form.link" class="preview-text-btn">إغلاق</span>
              <span v-if="form.allow_hide" class="preview-text-btn muted">عدم الإظهار مرة أخرى</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-1">
        <button class="btn btn-primary" @click="save()" :disabled="saving">
          {{ saving ? 'جاري الحفظ...' : 'حفظ' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BModal } from "bootstrap-vue";

function blank(){
  return { _id: null, apps: [], title: '', message: '', link: '', link_text: '', allow_hide: true, active: true };
}

export default {
  components: { BModal },
  directives: { "b-modal": VBModal },
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      list: [],
      form: blank(),
      saving: false,
      appNames: { parent: 'ولي الأمر', teacher: 'المعلم', school: 'المدرسة' },
    };
  },
  created() {
    this.load();
  },
  methods: {
    appName(key) {
      return this.appNames[key] || key;
    },
    load() {
      var g = this;
      $.post(api + '/admin/apps/messages', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.list = r.response;
      });
    },
    openNew() {
      this.form = blank();
      this.$bvModal.show('message');
    },
    openEdit(m) {
      this.form = Object.assign(blank(), JSON.parse(JSON.stringify(m)));
      this.$bvModal.show('message');
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/apps/messages/save', {
        jwt: this.jwt,
        id: this.form._id || '',
        apps: this.form.apps,
        title: this.form.title,
        message: this.form.message,
        link: this.form.link,
        link_text: this.form.link_text,
        allow_hide: this.form.allow_hide,
        active: this.form.active,
      }).then(function(r){
        g.saving = false;
        if(r.status != 100) return alert(r.response, 200);
        g.$bvModal.hide('message');
        g.load();
        alert('تم الحفظ، تظهر في التطبيقات خلال دقيقة تقريباً.', 100);
      }).fail(function(){
        g.saving = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
    toggle(m) {
      var g = this;
      $.post(api + '/admin/apps/messages/toggle', { jwt: this.jwt, id: m._id, active: !m.active }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.load();
      });
    },
    reshow(m) {
      if(!confirm('ستظهر الرسالة مرة أخرى لكل من اختار «عدم الإظهار مرة أخرى». متابعة؟')) return;
      var g = this;
      $.post(api + '/admin/apps/messages/reshow', { jwt: this.jwt, id: m._id }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.load();
        alert('ستظهر لهم مرة أخرى.', 100);
      });
    },
    remove(m) {
      if(!confirm('حذف الرسالة «' + (m.title || m.message) + '»؟')) return;
      var g = this;
      $.post(api + '/admin/apps/messages/delete', { jwt: this.jwt, id: m._id }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.load();
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.msg {
  max-width: 380px;
  white-space: pre-line;
}
.actions {
  white-space: nowrap;
}
.actions .btn + .btn {
  margin-right: 4px;
}
.preview {
  background: rgba(0, 0, 0, 0.55);
  border-radius: 16px;
  padding: 24px 16px;
}
.preview-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px 16px 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.preview-card p {
  color: #555;
  margin: 0;
  white-space: pre-line;
  font-size: 13px;
  line-height: 1.8;
}
.preview-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin: 0 auto;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.preview-btn {
  background: #7367f0;
  color: #fff;
  border-radius: 12px;
  padding: 10px;
  margin-top: 6px;
}
.preview-text-btn {
  color: #7367f0;
  font-size: 13px;
  padding: 4px;
}
.preview-text-btn.muted {
  color: #888;
}
</style>
